import { memo } from "react";
import { useDispatch } from "react-redux";
import { HubspotPage } from "../../../reducers/knowledgeBase.reducer";
import { setActivePageIds, routeKnowledgeBase, setKnowledgeBaseSubPage, setKnowledgeBaseURL } from "../../../actions";
import Error from "../Error";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DescriptionIcon from '@mui/icons-material/Description';

const Page = (props: { hubspotPages: HubspotPage[], design: any }) => {

  const dispatch = useDispatch();

  const route = (page: HubspotPage) => {

    if (page.pages && page.pages.length) {
      dispatch(setKnowledgeBaseSubPage(page.pages));
      dispatch(routeKnowledgeBase("subpage"));
      dispatch(setActivePageIds({ id: page.id || '', type: 'add' }));

    } else if (page.urls && page.urls.app) {
      dispatch(setKnowledgeBaseURL(page.urls.app));
      dispatch(routeKnowledgeBase("content"));
    }
  }

  return (
    <div id='ele-54' className="px-3 py-3 text-xl text-primaryText h-full overflow-hidden">
      <div id='ele-55' className="text-primaryText text-lg font-mSemiBold mb-2">Categories</div>
      <div id='ele-56' className="overflow-scroll h-full hide-scrollbar">
        {(props.hubspotPages || []).map(page => {
          return (
            <div className="ele-knowledgebase-hubspotpages flex flex-row items-center mb-2 py-1 px-1 rounded-md cursor-pointer bg-white" key={`kb-${page.title}`}
              onClick={() => route(page)}>

              <DescriptionIcon className="align-middle items-center text-primaryColor" style={{ color: props?.design?.themeColor }} />              
              <div className="flex flex-col w-5/6 px-3 ele-knowledgebase-hubspotpage-body">
                <div className="text-sm truncate w-4/5 ele-knowledgebase-hubspotpage-title">{page.title}</div>
                <div className="text-xs truncate w-4/5 leading-5 text-lightText ele-knowledgebase-hubspotpage-description">{page.description || page.title}</div>
              </div>

              <ChevronRightIcon className="align-middle items-center text-footer" />
            </div>
          )
        })}
        {
          !props.hubspotPages.length &&
          <div id='ele-61' className="flex mt-12"><Error type="No Category" /></div>
        }
      </div>
    </div>
  )
}

export default memo(Page);
